var _dec, _class, _temp;

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, html } from '@sick-davinci/ce-decorators';
import { style } from './Breadcrumb.style';
/**
 * A breadcrumb indicates the current page’s location.
 * It consists of several breadcrumb-item's which itself has a link to a page.
 * 
 * @example
 * ```html
 * <davinci-breadcrumb>
 *    <davinci-breadcrumb-item href="/home" label="Home"></davinci-breadcrumb-item>
 *    <davinci-breadcrumb-item label="Search" onclick="console.log('clicked')"></davinci-breadcrumb-item>
 * </davinci-breadcrumb>
 * ```
 * @slot {davinci-breadcrum-item[]} list of `davinci-breadcrum-item`
 */

export let Breadcrumb = (_dec = Component({
  tag: 'davinci-breadcrumb',
  style
}), _dec(_class = (_temp = class Breadcrumb extends CustomElement {
  constructor(...args) {
    super(...args);

    this._scrollFadeHandle = input => {
      const element = input.currentTarget;
      const width = element.clientWidth;
      const left = element.scrollLeft;
      const scrollWidth = element.scrollWidth;
      const right = Math.round(scrollWidth - left - width);
      this.fadeOutLeft = input.currentTarget.previousElementSibling;
      this.fadeOutRight = input.currentTarget.nextElementSibling;

      this._setFadeout(left, this.fadeOutLeft);

      this._setFadeout(right, this.fadeOutRight);
    };
  }

  render() {
    return html`
        <div class="fadeout-left fadeout-hidden"></div>
        <div class="scroll-container" @scroll="${event => {
      this._scrollFadeHandle(event);
    }}">
          <slot></slot>
        </div>
        <div class="fadeout-right"></div>
    `;
  }

  _setFadeout(direction, element) {
    const threshold = 0;

    if (direction > threshold) {
      element.classList.remove('fadeout-hidden');
    } else if (direction === threshold) {
      element.classList.add('fadeout-hidden');
    }
  }

}, _temp)) || _class);
//# sourceMappingURL=Breadcrumb.js.map